import { useFetchDriversQuery } from '@api/Trinium/Endpoints/Driver/slice';
import { useFetchTractorsQuery } from '@api/Trinium/Endpoints/Tractor/slice';
import { useMemo } from 'react';
import { ExtendedTractor } from './useDriverTractors.types';
import useCurrentTerminal from './useCurrentTerminal';

/** */
export function useFetchDriverTractors() {
  const { number: terminalNumber } = useCurrentTerminal();

  const { data: driverData, isFetching: driversLoading } = useFetchDriversQuery({ terminalNumber, isActive: true }); // only active drivers

  const { data: tractorData, isFetching: tractorsLoading } = useFetchTractorsQuery(terminalNumber);

  /** Drivers with their associated Trucks */
  const driversWithTractors = useMemo(() => {
    if (driverData && tractorData) {
      return driverData.map((driver) => ({
        ...driver,
        tractors: tractorData
          .filter((tractor) => tractor.ctrId === driver.ctrId)
          .map(
            (baseTractor) =>
              ({
                ...baseTractor,
                drivers: driverData.filter((driver) => driver.ctrId === baseTractor.ctrId)
              }) as ExtendedTractor
          )
      }));
    }
    return [];
  }, [driverData, tractorData]);

  /** Trucks with their associated Drivers */
  const tractorsWithDrivers = useMemo(() => {
    if (tractorData && driverData) {
      return tractorData.map((tractor) => ({
        ...tractor,
        drivers: driverData
          .filter((driver) => driver.ctrId === tractor.ctrId)
          .map((baseDriver) => ({
            ...baseDriver,
            tractors: [] as ExtendedTractor[]
          }))
      }));
    }
    return [];
  }, [tractorData, driverData]);

  return {
    driversWithTractors,
    tractorsWithDrivers,
    isLoading: driversLoading || tractorsLoading
  };
}
